<template>
  <v-form ref="form" v-model="valid" flat class="pa-4">
    <v-text-field
      :rules="required"
      label="Tên"
      v-model="title"
      outlined
      required
      dense
    ></v-text-field>
    <autocomplete-major
      v-model="rootMajor"
      item-text="title"
      item-value="id"
      label="Chuyên Ngành"
      :rules="required"
      return-object
      dense
      outlined
    ></autocomplete-major>
    <v-autocomplete
      :disabled="!isRootChosen"
      v-model="major"
      :items="getMajorsByRoot"
      item-text="title"
      item-value="id"
      label="Chuyên Ngành"
      return-object
      :rules="required"
      outlined
      dense
    />
    <autocomplete-course
      v-model="course"
      item-text="title"
      item-value="id"
      label="Khóa Học"
      :rules="required"
      dense
      outlined
    ></autocomplete-course>
    <v-textarea
      ref="description"
      v-model="description"
      label="Mô Tả"
      placeholder="Nhập mô tả"
      required
      dense
      outlined
    ></v-textarea>
    <v-text-field
      ref="link"
      v-model="link"
      label="Đường dẫn"
      placeholder="Nhập đường dẫn tới bài viết"
      hide-details="true"
      required
      dense
      outlined
    ></v-text-field>
    <v-file-input
      v-model="file"
      class="mt-4"
      color="deep-purple accent-4"
      label="File input"
      placeholder="Tải ảnh lên"
      :show-size="1000"
      required
      counter
      outlined
    >
      <template v-slot:selection="{ index, text }">
        <v-chip
          v-if="index < 2"
          color="deep-purple accent-4"
          dark
          label
          small
          >{{ text }}</v-chip
        >
        <span
          v-else-if="index === 2"
          class="overline grey--text text--darken-3 mx-2"
          >+{{ files.length - 2 }} File(s)</span
        >
      </template>
    </v-file-input>
    <v-text-field
      ref="embed"
      v-model="embed"
      label="Link nhúng (Embed code)"
      placeholder="Điền link nhúng"
      required
      dense
      outlined
    ></v-text-field>
  </v-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { Major } from '@/plugins/api'
import AutocompleteMajor from '@/components/basic/input/AutocompleteRootMajor.vue'
import AutocompleteCourse from '@/components/basic/input/AutocompleteCourse.vue'
export default {
  props: {
    showcase: Object,
    isEditing: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { AutocompleteMajor, AutocompleteCourse },
  data: () => ({
    valid: false,
    required: [(v) => !!v || 'Name is required'],
    description: '',
    title: '',
    major: '',
    link: '',
    course: '',
    rootMajor: '',
    isFeature: false,
    file: null,
    embed: '',
  }),
  computed: {
    ...mapGetters('app', ['department']),
    getMajorsByRoot() {
      if (this.rootMajor) return this.rootMajor.majors
      return []
    },
    isRootChosen() {
      return this.rootMajor !== null && typeof this.rootMajor !== 'undefined'
    },
  },
  async created() {
    await this.reset()
  },
  methods: {
    async getRootMajor(id) {
      return await Major.fetchOne(id)
    },
    async reset() {
      // this.$refs.form.reset()
      if (this.showcase) {
        this.$loading.active = true
        if (this.showcase.major)
          this.rootMajor = await this.getRootMajor(this.showcase.major.root)
        this.description = this.showcase.description
        this.title = this.showcase.title
        this.course = this.showcase.course
        this.link = this.showcase.link
        this.position = this.showcase.position
        this.major = this.showcase.major.id
        this.embed =
          this.showcase.data && this.showcase.data.link
            ? this.showcase.data.link
            : ''
        this.$loading.active = false
        this.file = null
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    validate() {
      this.$refs.form.validate()
      return this.valid
    },
    getData() {
      let data = {
        description: this.description,
        title: this.title,
        course: this.course,
        link: this.link,
        major: this.major.id,
        department: this.department.id,
        embed: this.embed,
      }
      if (this.file) data.file = this.file
      return data
    },
  },
  watch: {
    showcase(showcase) {
      this.reset()
    },
  },
}
</script>

<style scoped></style>
